import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { CLIENT_USERS_GET_MANY } from 'api/query-keys';
import type { TGetClientUserRes } from 'api/swagger';

export const useGetClientUsers = (clientId: number) => {
  return useQuery<TGetClientUserRes[]>({
    queryKey: [CLIENT_USERS_GET_MANY, clientId],
    queryFn: async () => {
      const { data } = await http.get<TGetClientUserRes[]>(`/v1/client-user/${clientId}`);

      return data;
    },
    refetchOnWindowFocus: false,
    retry: false,
  });
};
